import script from "./Spline.vue?vue&type=script&lang=js"
export * from "./Spline.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__